<div class="search-block">
  <app-search></app-search>
</div>
<app-notification [notification] = "notification" *ngIf="browserRefresh"></app-notification>
<br>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
  <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>

<app-quick-links [topArticle] = "topArticles"></app-quick-links>

<div *ngIf="showAuthFailedNotification" style="width: 100%; display: flex; justify-content: center; align-items: center;">
  <div class="auth-failed-notification">
    <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{authFailedMessage}}</p>
    <button (click)="closeAuthFailedNotification()">
      <i class="fa fa-window-close" aria-hidden="true"></i>
    </button>
  </div>
</div>